<template>
  <div class="login-page">
    <pageHeader />
    <section class="start">
      <div class="right-sec sec min-mobile">
        <div class="content1 auth-center">
          <div class="form-co">
            <div class="info">
              <h4>{{ $t("auth.pleasephone") }}</h4>
              <p class="gray-col font14">
                {{ $t("auth.defaultphase") }}
              </p>
            </div>
            <v-form @submit.prevent="ValidPassword" v-model="valid" ref="form">
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.newPass") }}</h6>
                <v-text-field
                  v-model="password"
                  type="password"
                  name="password"
                  :rules="rules"
                  :placeholder="$t('auth.passwordplace')"
                ></v-text-field>
                <div
                  class="absLeft pointer-click"
                  @click="toogleEyeIcon($event)"
                >
                  <div class="normalEye">
                    <i class="fa-regular fa-eye"></i>
                  </div>
                  <div class="slashedEye">
                    <i class="fa-regular fa-eye-slash"></i>
                  </div>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.passwordconfirm') }}</h6>
                <v-text-field
                  v-model="confirmPassword"
                  type="password"
                  :rules="confirmRules"
                  :placeholder="$t('auth.passwordplace')"
                  name="password_confirmation"
                ></v-text-field>
                <div
                  class="absLeft pointer-click"
                  @click="toogleEyeIcon($event)"
                >
                  <div class="normalEye">
                    <i class="fa-regular fa-eye"></i>
                  </div>
                  <div class="slashedEye">
                    <i class="fa-regular fa-eye-slash"></i>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up w-100 mt-4 xl"
              >
                <div v-if="!disabled">{{ $t('auth.confirm') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('auth.confirming') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
      <welcomeView />
    </section>
  </div>
</template>

<script setup>
import pageHeader from "../components/pageHeader.vue";
import welcomeView from "../components/home/welcomeView.vue";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
import i18n from "@/i18n";

// reactiv states
const valid = ref(false);
const disabled = ref(false);
const form = ref(null);
const password = ref("");
const confirmPassword = ref("");
const confirmRules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.passValid`);
  },
  (value) => {
    if (value === password.value) return true;

    return i18n.global.t(`auth.passValidId`);
  },
]);
const rules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.passValid`);
  },
]);

// functions
function toogleEyeIcon(event) {
  console.log(event.currentTarget);
  event.currentTarget.classList.toggle("toggleEye");
  let currentType = event.currentTarget.previousElementSibling
    .querySelector("input")
    .getAttribute("type");
  console.log(currentType);
  if (currentType == "text") {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "password");
  } else {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "text");
  }
}

function ValidPassword() {
  if (valid.value) {
    changePassword();
  }
}

function changePassword() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  // fd.append("type", SendedVal.value);
  fd.append("code", localStorage.getItem("otpsNumber"));
  fd.append("country_code", localStorage.getItem("country_code"));
  fd.append("phone", localStorage.getItem("phone"));
  fd.append("lang", localStorage.getItem("lang"));

  axios.post("/manager/reset-password", fd).then((response) => {
    if (response.data.key == "success") {
      console.log(response.data);
      toast.add({
        severity: "success",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      router.push("/loginView");
    } else {
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
    }
    disabled.value = false;
  });
}

onMounted(() => {});
</script>
